<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

	
    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.projectName" label="项目名称" label-width="130px" readonly autosize rows='1' type="textarea"/>
		<van-field v-model="inputForm.year" label="年度" label-width="130px" readonly autosize rows='1' type="textarea"/>
		<van-field v-model="inputForm.departName" label="编制部门" label-width="130px" readonly autosize rows='1' type="textarea"/>
		<van-field v-model="inputForm.createName" label="制单人" label-width="130px" readonly autosize rows='1' type="textarea"/>
		<van-field v-model="inputForm.createDate" label="制单时间" label-width="130px" readonly autosize rows='1' type="textarea"/>
		<van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly autosize rows='1' type="textarea"/>
	  </van-collapse-item>
      <van-collapse-item title="附件" name="2">
		<p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        <div class="m-row" v-if="inputForm.attachList && inputForm.attachList.length==0">无</div>
      </van-collapse-item>
	  <van-collapse-item title="分摊明细" name="3">
		  请至PC端查看
	  </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import DecomposeService from "@/api/cost/DecomposeService";
import processRecord from "../../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        projectId:'',
        year: '',
        type: '',
        remarks: '',
        pullDate: '',
        departName: '',
        projectName: '',
        createDate: '',
        createName: '',
        attachIds: [],
        attachList: [],
        isDoTask: false,
        isLastTask: false
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(this.businessId)
    // if(!window.matchMedia("(orientation:portrait)").matches){
    //   dd.device.screen.resetView({
    //     onSuccess : function(result) {
    //     },
    //     onFail : function(err) {}
    //   });
    // }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new DecomposeService().queryById(id).then(({data}) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'shye_fee_assessment',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: _this.inputForm.isLastTask ? 4 : 2,
				formKey: _this.formKey
			}
            new DecomposeService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: 3,
				formKey: _this.formKey
			}
            new DecomposeService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>
